<template>
  <div>
    <vs-dropdown vs-trigger-click class="cursor-pointer ml-3" vs-custom-content :disabled="isDisabledItems">
      <div class="p-3 cursor-pointer">
        <span class="mr-2 leading-none"><vs-icon style="font-size: 25px" icon-pack="material-icons"
            icon="reorder" /></span>
      </div>

      <vs-dropdown-menu>
        <vs-dropdown-item @click="handleDropdownClick(action, params.data)" v-for="(action, index) in contextMenus"
          :key="index" :class="{ drop_dsbl: isDisabled(params.data, action.action) }">
          <span class="flex items-center">
            <span>{{ action.name }}</span>
          </span>
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  name: "CellRendererApActions",
  watch: {
    "$store.state.isDisabledAllFields"(val) {
      this.toggleIsDisabledItems(val);
    },
  },
  methods: {
    isDisabled(data, action) {
      return (
        data.disabled &&
          action !== 'detachHardwareAcu' &&
          action !== 'deleteAcu' &&
          action !== 'copyAcu' &&
          action !== 'pasteAcu' &&
          action == 'synchronization' ? data.status !== "active" || data.cloud_status !== "online" : false
      );
    },
    handleDropdownClick(action, data) {
      if (action.action === "synchronization") {
        if (data.status !== "active" || data.cloud_status !== "online") {
          this.$vs.notify({
            time: 7000,
            color: "danger",
            title: "For synchronization ACU should be online ",
          });
          return false;
        }
      }
      const allowedActions = [
        'deleteAcu',
        'detachHardwareAcu',
        'copyAcu',
        'pasteAcu',
        'synchronization',
      ];

      if (!data.disabled || allowedActions.includes(action.action)) {
        this.$root.$emit(action.action, data);
      } else {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "You cannot do this on an activated device.",
        });
        return false;
      }
    },
    toggleIsDisabledItems(val) {
      this.isDisabledItems = val;
    },
  },
  mounted() {
    this.isDisabledItems = this.$store.state.isDisabledAllFields;
  },
  data() {
    return {
      contextMenus: [
        // { name: "Activate", action: "activateAcu" },
        { name: "Synchronization", action: "synchronization", disabled: false },
        { name: "Copy", action: "copyAcu" },
        { name: "Paste", action: "pasteAcu", disabled: true },
        { name: "Attach Hardware", action: "attachHardwareAcu" },
        { name: "Change Acu", action: "detachHardwareAcu" },
        { name: "Edit", action: "updateItemAcu" },
        { name: "Delete", action: "deleteAcu" },
      ],
      isDisabledItems: false
    };
  }
};
</script>
